import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom';
import AdminMenu from '../components/common/AdminMenu';
import AdminSidebar from '../components/common/AdminSidebar';
import Footers from '../components/common/Footers';
import Menu from '../components/common/Menu';
import Submenu from '../components/common/Submenu';
import UserPanelMenu from '../components/common/UserPanelMenu';
import UserPanelSidebar from '../components/common/UserPanelSidebar';
// import { useUserInfo } from '../context/UserContext';


const AdminLayout = ({ children,setregister }) => {
  // const {getUser} = useUserInfo();
  // useEffect(() => {
  //   getUser.reFetch()

  // }, [])
  

  return (
    <div className='UserPanelLayout'>
      
      <AdminSidebar/>
      <div/>
     
      <div className=''>
      <AdminMenu/>
      <main className=' AdminLayout--main'>
        <div className=' AdminLayout--container'>
        <Outlet />
        </div>
    
      </main>
      
       
      </div>

 
    </div>
  )
}

export default AdminLayout